<template>
  <div class="tabSlide">

    <div class="swiper">
      <ul class="tab-tilte">
        <li @click="Swiper.slidePrev();cur=0;"><a href="#">产品详情</a><i :class="{active:cur==0}"></i></li>
        <span v-if="notice.listdata.length>0"></span>
        <li v-if="notice.listdata.length>0" @click="Swiper.slideNext();cur=1;" ><a href="#">推荐搭配</a><i :class="{active:cur==1}"></i></li>
      </ul>
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide><img :style="{ height : detailheight + 'px' }"  ref="imgSize" @onload="imgload" style="width:100%;" :src="imgsrc + notice.detailsimg" alt=""></swiper-slide>
        <swiper-slide v-if="notice.listdata.length>0">
            <div style=" background: url(../../static/mobile/productbg.png) no-repeat;background-size: 100% 100%;overflow: hidden;">
              <ul class="listone">
                <li v-for="(item, index) in notice.listdata" :key="index">
                  <div>
                    <img  :src="imgsrc + item.cover" alt="">
                  </div>
                  <p>{{ item.name }}</p>
                  <h5 v-if="isPriceOnRequest(item.unit_price)" class="price-fallback">价格详询在售渠道</h5>
                  <h5 v-else>￥{{ (+ item.unit_price).toFixed(2) }}</h5>
                  <router-link :to="{ name:'Product', query: {id: item.id} }">
                    查看产品
                  </router-link>
                </li>
              </ul>
            </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
//导入swiper
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'tabSlide',
  data() {
    return {
      cur:0,
      detailheight:0,
      swiperOptions: {
        autoHeight: true,      
        on:{
          slideChange:()=>{
            this.cur=this.Swiper.activeIndex
            this.Swiper.updateAutoHeight(0)
          }
        }
      }
    };
  },
  props:['notice'],
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    Swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted(){
    this.imgload()
  },
  methods:{
    isPriceOnRequest(p) {
      const n = Number(p);
      return !Number.isFinite(n) || n <= 0;
    },
    imgload(){
      let that=this
      this.$nextTick(()=>{
        let img=this.$refs['imgSize']
        img.onload=function(){
          that.detailheight = img.clientWidth*img.naturalHeight/img.naturalWidth;
        }
      })
    }
}
};
</script>

<style lang="less">
.price-fallback {
  font-size: 0.75em !important;
  font-weight: normal !important;
}
.tabSlide{
  .tab-tilte{
    display: flex;
    padding-bottom: 0.02rem;
    justify-content: space-around;
    li{
      width: 50%;
      font-size: 0.33rem;
      font-weight: 900;
      color: #00383F;
      position: relative;
    }
    span{
      width: 2px;
      height: 0.5rem;
      background: #00383F;
      display: inline-block;
    }
      a{
        display: inline-block;
        padding-bottom: 0.17rem;
      }
  .active{
      display: inline-block;
      display: inline-block;
      width: 1.6rem;
      height: 0.06rem;
      background:#00383F ;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .listone{
    padding-top: 0.5rem;
    margin: 0 0.6rem;
    li{
      display: inline-block;
      width: 2.9rem;
      color: #00383F;
      float: left;
      div{
           border: 1px solid #00383F;
            border-radius: 5px;
            background: #fff;
        img{
          width: 2.7rem;
          padding: 0.5rem 0;
        }
      }
      p{
        width: 2.1rem;
        margin: 0 auto;
        font-size: 0.33rem;
        margin-top: 0.34rem;
        height: 0.8rem;

      }
      h5{
        font-size: 0.25rem;
        margin-top: 0.45rem;
      }
      a{
        display: inline-block;
        width: 2.1rem;
        height: 0.65rem;
        background: #00383F;
        font-size: 0.33rem;
        font-weight: 900;
        color: #fff;
        line-height: 0.65rem;
        margin: 0.3rem 0 0.7rem 0;
      }
    }
    li:nth-child(2n){
      margin-left: 0.5rem;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabSlide.vue